import {combineReducers} from 'redux';
import {getSuccessActionType} from '../utils';
import {getErrorReducer, getStatusReducer} from './utils/generators';
import {CHECK_SMS_KEY, FETCH_USER_DATA, UPDATE_USER_DATA, CREATE_USER} from '../constants/user';
import {FETCH_STUDENT_DATA} from '../constants/student';
import {ACCESS_TOKEN_KEY} from '../constants';

function data(state = {}, action) {
  switch (action.type) {
    case getSuccessActionType(FETCH_USER_DATA):
      return action.payload;

    case getSuccessActionType(FETCH_STUDENT_DATA):
      return action.payload.user;

    case getSuccessActionType(UPDATE_USER_DATA):
      return action.payload;

    case getSuccessActionType(CHECK_SMS_KEY):
      return {...state, mobileVerified: true};

    case getSuccessActionType(CREATE_USER):
      const {token, ...data} = action.payload;
      localStorage.setItem(ACCESS_TOKEN_KEY, token);
      return data;

    default:
      return state;
  }
}

export default combineReducers({
  status: getStatusReducer([FETCH_USER_DATA, FETCH_STUDENT_DATA]),
  error: getErrorReducer([FETCH_USER_DATA, FETCH_STUDENT_DATA]),
  data
});
